import React from 'react';
import { useEffect, useState } from "react";
import axios from "axios";
import useReactApexChart from '../../hook/useReactApexChart';
import PostByAgg from '../../utils/axios';
import { useAuth } from '../../context/AuthContext';
import noDataAlt from "../../assets/animations/no-data-alt.json"; 
import Lottie from 'lottie-react';



const RevenueEveryMonth = () => {
    const [chartData, setChartData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState(String(new Date().getFullYear()));

    const {createBarChartWithHighlight} = useReactApexChart();

    const { musicLabelCode } = useAuth()

    const yearOptions = ["2022", "2023", "2024","2025"];
    const monthOptions = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const GetRevenueEveryMonth = () => {
        setLoading(true);
        const url = 'song/v1/track/monthly-revenue-by-music-label'

        PostByAgg({
            url,
            body: {
                'music_label_code': musicLabelCode,
                'year':selectedYear
            },
            onResponse:onResponseChartMonth,
            onError: onErrorChartMonth
        })
    }

    const onResponseChartMonth = (response) => {
        console.log("response chart",response.data.data)
        setChartData(response.data.data)
        setLoading(false)
    }

    const onErrorChartMonth = (err)  => {
        console.log("error Chart", err)
    }

     useEffect(() => {
  if (selectedYear && musicLabelCode) {
    setSelectedMonth(""); // Reset bulan ketika tahun diganti
    GetRevenueEveryMonth(selectedYear);
  }
}, [selectedYear, musicLabelCode]);


    const monthIndex = chartData?.categories?.indexOf(selectedMonth);
    const revenueForSelectedMonth =
        monthIndex !== -1 && monthIndex !== undefined
            ? chartData?.series?.[0]?.data?.[monthIndex]
            : null;


    return (
        <div className="col-xxl-12 col-md-6">
            <div className="card h-100">
                <div className="card-header border-bottom d-flex align-items-center flex-wrap gap-2 justify-content-between">
                    <h6 className="fw-bold text-lg mb-0">Revenue Every Month</h6>
                    <select
                        className="form-select form-select-sm w-auto"
                        value={selectedYear}
                        onChange={(e) => setSelectedYear(e.target.value)}
                    >
                        {yearOptions.map((year) => (
                            <option key={year} value={year}>{year}</option>
                        ))}
                    </select>

                    <select
                        className="form-select form-select-sm w-auto bg-base border text-secondary-light rounded-pill"
                        value={selectedMonth}
                        onChange={(e) => setSelectedMonth(e.target.value)}
                    >
                        <option value="" disabled>Select Month</option>
                        {monthOptions.map((month) => (
                            <option key={month} value={month}>{month}</option>
                        ))}
                    </select>
                </div>
                <div className="card-body">
                   {selectedMonth && (
                        <p className="mb-3 text-sm">
                            Revenue for <strong>{selectedMonth}</strong>:{" "}
                            {revenueForSelectedMonth === 0 || revenueForSelectedMonth === null
                            ? <strong>Tidak ada revenue</strong>
                            : <strong>Rp {revenueForSelectedMonth.toLocaleString("id-ID")}</strong>}
                        </p>
                    )}
                    <div
                        id="enrollmentChart"
                        className="apexcharts-tooltip-style-1 yaxies-more"
                    >
                        {loading && <p>Loading chart...</p>}
                       {!loading && chartData && chartData.series?.[0]?.data?.length > 0 ? (
                        selectedMonth ? (
                            revenueForSelectedMonth === 0 || revenueForSelectedMonth === null ? (
                            <div className="d-flex flex-column align-items-center justify-content-center py-5">
                                <Lottie animationData={noDataAlt} loop autoplay style={{ height: 200 }} />
                                <p className="fw-semibold mt-3 mb-1">Belum ada revenue 😶</p>
                                <p className="text-sm text-secondary-light">
                                Coba pilih tahun atau bulan lain ya!
                                </p>
                            </div>
                            ) : (
                            createBarChartWithHighlight(chartData, selectedMonth) // Tetap render full chart
                            )
                            ) : (
                                createBarChartWithHighlight(chartData) // Saat belum pilih bulan, tetap tampilkan chart
                            )
                        ) : null}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RevenueEveryMonth;